export default __webpack_public_path__ + "static/media/facebook-logo.cc03dd42.svg";